var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_2693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6397 35C59.2535 35 60.8385 46.009 60.8385 46.009L60.8667 57.4146H85.0924V60.8389H51.2447C51.2447 60.8389 35 58.9966 35 84.6111C35 110.226 49.1788 109.318 49.1788 109.318H57.6406V97.4315C57.6406 97.4315 57.1844 83.2527 71.593 83.2527H95.6205C95.6205 83.2527 109.12 83.4708 109.12 70.206V48.2734C109.12 48.2734 111.17 35 84.6397 35ZM71.2817 42.6701C71.8542 42.6696 72.4211 42.7819 72.9501 43.0008C73.4791 43.2196 73.9598 43.5406 74.3646 43.9454C74.7693 44.3502 75.0903 44.8308 75.3092 45.3598C75.528 45.8888 75.6404 46.4558 75.6399 47.0282C75.6404 47.6007 75.528 48.1676 75.3092 48.6966C75.0903 49.2256 74.7693 49.7063 74.3646 50.1111C73.9598 50.5159 73.4791 50.8369 72.9501 51.0557C72.4211 51.2745 71.8542 51.3869 71.2817 51.3864C70.7092 51.3869 70.1423 51.2745 69.6133 51.0557C69.0843 50.8369 68.6037 50.5159 68.1989 50.1111C67.7941 49.7063 67.4731 49.2256 67.2542 48.6966C67.0354 48.1676 66.923 47.6007 66.9235 47.0282C66.923 46.4558 67.0354 45.8888 67.2542 45.3598C67.4731 44.8308 67.7941 44.3502 68.1989 43.9454C68.6037 43.5406 69.0843 43.2196 69.6133 43.0008C70.1423 42.7819 70.7092 42.6696 71.2817 42.6701Z",
    fill: "url(#paint0_linear_202_2693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3611 134.482C110.747 134.482 109.162 123.473 109.162 123.473L109.134 112.068H84.908V108.644H118.756C118.756 108.644 135 110.486 135 84.8707C135 59.2557 120.822 60.1641 120.822 60.1641H112.36V72.0503C112.36 72.0503 112.816 86.229 98.4074 86.229H74.3799C74.3799 86.229 60.8805 86.0109 60.8805 99.2762V121.209C60.8805 121.209 58.831 134.482 85.3611 134.482ZM98.7191 126.813C98.1466 126.814 97.5797 126.701 97.0507 126.482C96.5217 126.263 96.0411 125.942 95.6363 125.538C95.2315 125.133 94.9105 124.652 94.6916 124.123C94.4728 123.594 94.3604 123.027 94.3609 122.455C94.3604 121.882 94.4727 121.315 94.6915 120.786C94.9103 120.257 95.2313 119.777 95.6361 119.372C96.0409 118.967 96.5216 118.646 97.0506 118.427C97.5796 118.208 98.1466 118.096 98.7191 118.096C99.2916 118.096 99.8585 118.208 100.387 118.427C100.916 118.646 101.397 118.967 101.802 119.372C102.207 119.776 102.528 120.257 102.747 120.786C102.965 121.315 103.078 121.882 103.077 122.454C103.078 123.027 102.965 123.594 102.747 124.123C102.528 124.652 102.207 125.132 101.802 125.537C101.397 125.942 100.916 126.263 100.387 126.482C99.8585 126.701 99.2916 126.813 98.7191 126.813Z",
    fill: "url(#paint1_linear_202_2693)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_2693",
    x1: 44.61,
    y1: 43.9476,
    x2: 94.1669,
    y2: 93.0102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_2693",
    x1: 75.0285,
    y1: 75.4549,
    x2: 128.247,
    y2: 125.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_2693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(35 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonLogo);
export default __webpack_public_path__ + "static/media/pythonLogo.e6bc457ab2fde2b0f464b37da941ac5a.svg";
export { ForwardRef as ReactComponent };